define('viewmodels/pages/games/top',['underscore', 'knockout', 'common/tools'], function (_, ko, tools) {

    var DEFAULT_GAMES_PER_ROW = 4;
    var GAMES_PER_ROW_BREAKPOINTS = {
        'mobile-portrait': 2,
        'mobile-landscape': 4,
        'tablet-portrait': 3,
        'tablet-landscape': 4
    };

    var TopGames = function(topLists, tabs, getField, getAllGamesField, mediaResponder) {
        this.topLists = topLists.lists;
        this.subNav = tabs;
        this.meta = {
            title: getField('meta_title'),
            description: getField('meta_description')
        };

        this.allGamesButtonText = getAllGamesField('tab_title');
        this.allGamesButtonCssClass = ko.deferredComputed(function() {
            return ko.unwrap(mediaResponder.isTablet()) ? '' : 'full-width';
        });
        var currentBreakpoint = mediaResponder.findBreakpointBy(_.keys(GAMES_PER_ROW_BREAKPOINTS));

        this.getGames = _.memoize(function(list) {
            return ko.pureComputed(function () {
                var itemsPerRow = GAMES_PER_ROW_BREAKPOINTS[currentBreakpoint()] || DEFAULT_GAMES_PER_ROW,
                    numOfRows = Math.floor(list().length / itemsPerRow),
                    numberOfGames = numOfRows > 0 ? itemsPerRow * numOfRows : list().length;

                return _.take(list(), numberOfGames);
            });
        }, function(a) { return tools.objToHash(a); });
    };

    return TopGames;
});

